// theirs
import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'

// ours
import { ContentDataModel } from '../../../interfaces'
import { introOurStoryBaseClass, StyledIntroOurStory } from './style'
import { appendLocationSingle } from '../../../utils/append-location'
import { CollectionContext, CollectionContextInterface } from '../../../App'
import { animationVariants } from '../../../animations'

export interface IntroOurStoryProps {
    className?: string
    testId?: string
    content: ContentDataModel
    collectionContext?: CollectionContextInterface
    animationControls?: any
}

const IntroOurStory = ({
    className,
    testId,
    content,
    animationControls,
}: IntroOurStoryProps) => {
    const collectionContext = React.useContext(CollectionContext)

    return (
        <StyledIntroOurStory
            className={classNames(introOurStoryBaseClass, className)}
            data-testid={testId}
            content={content}
            collectionContext={collectionContext || undefined}
        >
            <div className="content-outer">
                <div className="content-inner">
                    {content.contentTitle && (
                        <motion.div
                            variants={animationVariants.mainTitle}
                            initial="hidden"
                            animate={animationControls}
                            className="title-wrapper"
                        >
                            <h2>{content.contentTitle}</h2>
                        </motion.div>
                    )}
                    {content.contentText && (
                        <motion.div
                            variants={animationVariants.paragraphContainerSlow}
                            initial="hidden"
                            animate={animationControls}
                            className="text-wrapper"
                        >
                            <p>
                                {content.contentText
                                    .replace(/<\/br>/gi, ' </br> ') //
                                    .replace(/<i>/gi, ' <i>')
                                    .replace(/<\/i>/gi, '</i> ')
                                    .replace(/<b>/gi, ' <b>')
                                    .replace(/<\/b>/gi, '</b> ')
                                    .replace(/\s\s+/g, ' ')
                                    .split(' ')
                                    .map((elements, index) => {
                                        return elements === '</br>' ? (
                                            <br key={index} />
                                        ) : (
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    fontWeight:
                                                        elements.includes('<b>')
                                                            ? 'bold'
                                                            : undefined,
                                                    fontStyle:
                                                        elements.includes('<i>')
                                                            ? 'italic'
                                                            : undefined,
                                                }}
                                                key={index}
                                            >
                                                <motion.span
                                                    variants={
                                                        animationVariants.paragraphItem
                                                    }
                                                >
                                                    {`${elements
                                                        .replace(/<\/br>/gi, '')
                                                        .replace(/<i>/gi, '')
                                                        .replace(/<\/i>/gi, '')
                                                        .replace(/<b>/gi, '')
                                                        .replace(
                                                            /<\/b>/gi,
                                                            ''
                                                        )} `}
                                                </motion.span>
                                            </span>
                                        )
                                    })}
                            </p>
                        </motion.div>
                    )}
                </div>
            </div>
            {content.contentHelpText && (
                <div className="help-text-wrapper">
                    <motion.div
                        initial="hidden"
                        animate={animationControls}
                        variants={animationVariants.scrollExplore}
                        className="help-text"
                    >
                        {content.contentHelpText}
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        animate={animationControls}
                        style={{ originY: 0 }}
                        variants={animationVariants.verticalLine}
                        className="vertical-line"
                    />
                </div>
            )}
            {content.contentPicture && (
                <div className="video-wrapper">
                    {(collectionContext?.isPhone ||
                        collectionContext?.isTablet) && (
                        <video
                            playsInline
                            autoPlay
                            muted
                            loop
                            key={content.contentPicture[0].contentPictureClass}
                            className={
                                content.contentPicture[0].contentPictureClass
                            }
                            data-testid={
                                content.contentPicture[0].contentPictureTestId
                            }
                        >
                            <source
                                type="video/mp4"
                                src={appendLocationSingle(
                                    'images',
                                    content.contentPicture[0]
                                        .contentPictureImageSource
                                )}
                                media={
                                    content.contentPicture[0]
                                        .contentPictureMediaCondition
                                }
                            />
                        </video>
                    )}
                    {collectionContext?.isDesktop && (
                        <video
                            playsInline
                            autoPlay
                            muted
                            loop
                            key={content.contentPicture[1].contentPictureClass}
                            className={
                                content.contentPicture[1].contentPictureClass
                            }
                            data-testid={
                                content.contentPicture[1].contentPictureTestId
                            }
                        >
                            <source
                                type="video/mp4"
                                src={appendLocationSingle(
                                    'images',
                                    content.contentPicture[1]
                                        .contentPictureImageSource
                                )}
                                media={
                                    content.contentPicture[1]
                                        .contentPictureMediaCondition
                                }
                            />
                        </video>
                    )}
                </div>
            )}
        </StyledIntroOurStory>
    )
}

export default IntroOurStory
